import { compose } from 'redux'
import { connect } from 'react-redux'

// import { carregarRelatorio } from '../../actions'



const mapStateToProps = (state, props) => {
    return {};
};


export default compose(
    connect(mapStateToProps, {  })

);


// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/ItemRelatorio/ItemRelatorio.enhancer.js